import React from "react";
import { Link } from "react-router-dom";
import MarketingHeader from "@/components/MarketingHeader";
import { FEATURE_GROUPS } from "@/lib/marketingNav";

export default function Features() {
  return (
    <div className="mkt-page" data-testid="page-features">
      <MarketingHeader />

      <section className="mkt-hero">
        <div className="mkt-eyebrow">◢ PLATFORM</div>
        <h1 className="mkt-h1">Everything it takes to find, write, and submit a winning proposal</h1>
        <p className="mkt-sub">
          GovCo.AI covers the full lifecycle — from spotting a solicitation on SAM.gov to shipping a
          compliant, submission-ready package — in one connected workspace.
        </p>
      </section>

      <section className="mkt-body">
        <div className="feat-hub-grid">
          {FEATURE_GROUPS.map((group, i) => (
            <Link to={`/features/${group.slug}`} className="feat-hub-card" key={group.slug} data-testid={`feat-hub-${group.slug}`}>
              <div className="mkt-fgroup-index">0{i + 1}</div>
              <h2 className="mkt-h3">{group.title}</h2>
              <p className="feat-hub-summary">{group.summary}</p>
              <span className="feat-hub-link">Explore {group.items.length} features →</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="mkt-final-cta">
        <h2 className="mkt-h2">See it on your own pipeline</h2>
        <p className="mkt-sub">No card, no commitment — just your next solicitation.</p>
        <a className="mkt-cta-btn" href="/#demo" data-testid="features-cta">Schedule a demo →</a>
      </section>
    </div>
  );
}
